export default __webpack_public_path__ + "static/media/logo.41b6f6f6.jpg";